module.exports = __webpack_public_path__ + "static/media/code-branch.5c12275a.svg";